import { GetterTree } from 'vuex'

import { AIAssistantState } from './state'

export const getters: GetterTree<AIAssistantState, any> = {
  shouldShowQuestionTypePicker: (state, _getters, rootState, rootGetters): boolean => {
    const locale = rootState?.user?.profile?.locale ?? null
    const isFrenchLocale = locale === 'fr'

    const isProtegeAskEnabled = Boolean(rootGetters['user/isProtegeAskEnabled'])
    const isProtegeAskDocEnabled = Boolean(rootGetters['user/isProtegeAskDocEnabled'])

    return (
      isFrenchLocale &&
      isProtegeAskEnabled &&
      isProtegeAskDocEnabled &&
      !state.conversationActiveId &&
      !state.questionType
    )
  },
}
